import React from 'react';
import classNames from 'classnames';

import Box from '../box/box.jsx';
import Selector from './selector.jsx';
import styles from './asset-panel.css';
import PropTypes from 'prop-types';
import {useReadOnly, READ_ONLY_BLOCK_CLASS} from '../../playground/jm-read-only.js';

const AssetPanel = props => {
    const {ariaLabel, ariaRole, ...restProps} = props;
    const readOnly = useReadOnly();

    return (<Box
        aria-label={ariaLabel}
        role={ariaRole}
        className={styles.wrapper}
        element="section"
    >
        <Selector
            className={styles.selector}
            {...restProps}
        />
        <Box
            className={classNames(styles.detailArea, {[READ_ONLY_BLOCK_CLASS]: readOnly})}
            element="section"
        >
            {props.children}
        </Box>
    </Box>);
};

AssetPanel.propTypes = {
    ariaLabel: PropTypes.string,
    ariaRole: PropTypes.string,
    ...Selector.propTypes
};

export default AssetPanel;
